'use client';

import { useTranslations } from 'next-intl';
import { DOCS_URL } from '@/lib/constants/docs';
import { Link } from '@/lib/routing';

export function OrderFormTerms() {
  const t = useTranslations('orderForm');

  return (
    <span className="flex items-center justify-center gap-1 text-[10px] leading-none tracking-[0]">
      <span className="text-v2-text-primary opacity-50">{t('termsAgreement')}</span>
      <Link href={DOCS_URL.termsOfService} target={'_blank'} className="text-v2-text-primary">
        {t('termsAndConditions')}
      </Link>
    </span>
  );
}
